import { Row, Col } from 'antd';
import React from 'react';
import { Modal } from 'react-bootstrap';



const AttestationDialog = ({ show, handleCancel, attestationData}) => {
    return (
         <>
            <Modal className='centered-title-modal' size="lg" show={show} onHide={handleCancel} centered style={{fontSize: 12 }} >

                <Modal.Header closeButton centered style={{display:'block', fontSize: 24 }}>
                    Attestation Details
                </Modal.Header>

                <div>
                   
                    {attestationData &&
                     <>
                    <Row> <Col span={24}><div className='head-txt heading-title'>{attestationData.assetName}{attestationData.bubbleNo && ` (${attestationData.bubbleNo})`}</div></Col></Row>
                        
                        <Row>
                            <Col span={24} className='space-btm'>

                                <div className='' >
                                    <Row>
                                        <Col style={{textAlign:'center', fontSize:16}} span={24}><b><u>Request Information</u></b></Col>
                                    </Row>
                                    <Col style={{marginLeft:'auto', marginRight:'auto'}}>
                                     <Row>
                                        <Col span={12}>Request ID:</Col>
                                        <Col span={12}>{attestationData.attestationId}</Col>
                                    </Row>
                                    <Row>
                                        <Col span={12}>Request Status:</Col>
                                        <Col span={12}>{attestationData.requestStatus}</Col>
                                    </Row>
                                    <Row>
                                        <Col span={12}>Attestor:</Col>
                                        <Col span={12}>{attestationData.requestAttestor}</Col>
                                    </Row>
                                    <Row>
                                        <Col span={12}>Requester:</Col>
                                        <Col span={12}>{attestationData.requester}</Col>
                                    </Row>
                                    </Col>
                                </div>
                                <div className='spacing-section'>
                                     <Row>
                                        <Col style={{textAlign:'center', fontSize:16}} span={24}><b><u>Asset Information</u></b></Col>
                                    </Row>
                                    <Col style={{alignItems:'center'}}>
                                    <Row>
                                        <Col span={12}>Attestation Status:</Col>
                                        <Col span={12}>{attestationData.attestationStatus}</Col>
                                    </Row>
                                     <Row>
                                        <Col span={12}>Attestor:</Col>
                                        <Col span={12}>{attestationData.assetAttestor}</Col>
                                    </Row>                                   
                                    <Row>
                                        <Col span={12}>Attestation Date:</Col>
                                        <Col span={12}>{attestationData.attestorDate && attestationData.attestorDate.split('T')[0]}</Col>
                                    </Row>
                                    <Row>
                                        <Col span={12}>IPS Asset ID:</Col>
                                        <Col span={12}>{attestationData.objectId}</Col>
                                    </Row>
                                    <Row>
                                        <Col span={12}>IPS Internal Reference:</Col>
                                        <Col span={12}>{attestationData.internalRef}</Col>
                                    </Row>
                                    </Col>
                                </div>
                            </Col>
                        </Row>
                         </>
                    }

                </div>
            </Modal>
        </>
    )
};

export default AttestationDialog;